export default __webpack_public_path__ + "static/media/footer-logo.e56d394d.svg";